/**
 * Which template-creation flow a session belongs to.
 *
 * Settled when the session is created and read back on every load, so it — not the feature flag —
 * is what decides how an existing conversation behaves. The flag says what a *new* session is opened
 * as; a session already under way keeps the flow it was opened with, which is the same answer
 * manager-agent's own instructions fork on and the backend runs blueprints from. Reading the flag
 * instead meant a conversation could change flow under the client mid-chat (flags resolve
 * asynchronously), leaving the agent waiting at a review step the page had stopped rendering.
 *
 * Its own module rather than a constant in the chat API: the socket context reads it too, and
 * importing the API module there pulls the auth/token graph into a file that is loaded before any of
 * it — which is a cycle, not a dependency.
 */
export const SESSION_FLOW = {
  Legacy: 'legacy',
  Blueprint: 'blueprint',
} as const;

export type SessionFlow = (typeof SESSION_FLOW)[keyof typeof SESSION_FLOW];
